angular
  .module('fca-used')
  .directive('fragment', FragmentDirective);

FragmentDirective.$inject = ['$window', '$compile', '$http'];

function FragmentDirective($window, $compile, $http) {
  return {
    link: function (scope, elem, attr) {
      $http.get(attr.src)
        .then(function (response) {
          var eloqua = $window.document.createElement('html');
          eloqua.innerHTML = response.data;
          var form = eloqua.getElementsByTagName('section-eloqua')[0];
          var scripts = form.getElementsByTagName('script');
          var length = scripts.length;
          for (var i = 0; i < length; i++) {
            var script = scripts[i];
            if (script.getAttribute('data-ngtype') === 'text/javascript-lazy') {
              var s = $window.document.createElement('script');
              s.async = false;
              s.type = 'text/javascript';
              var src = script.getAttribute('src');
              if (angular.isDefined(src)) {
                s.setAttribute('src', src);
              } else {
                var code = script.innerHTML;
                s.text = code;
              }
              $window.document.head.appendChild(s);
            }
          }
          while (length--) {
            scripts[length].parentNode.removeChild(scripts[length]);
          }

          // Horrible workaround for nested forms on Chrome. Thanks Sharepoint.
          var mockForm = $window.document.createElement('form');
          mockForm.setAttribute('style', 'display: none !important;');
          form.insertBefore(mockForm, form.childNodes[0]);

          elem.html(form.outerHTML);
          $compile(elem.contents())(scope);
        });
    }
  };
}
